import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1fdd6bc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "admin-video",
  class: "container pt-36 pb-56"
}
const _hoisted_2 = { class: "form-actions mb-24" }
const _hoisted_3 = { class: "mb-12" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-expand-right me-12"
}, null, -1))
const _hoisted_5 = { class: "h4 title fw-normal mb-32 text-primary" }
const _hoisted_6 = { class: "fw-bold" }
const _hoisted_7 = { class: "pb-24 pb-lg-64" }
const _hoisted_8 = { class: "iframe-container" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "form" }
const _hoisted_11 = { class: "d-flex justify-content-between" }
const _hoisted_12 = { class: "legend" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-edit-light me-8"
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-trash me-8"
}, null, -1))
const _hoisted_15 = { class: "row gx-32" }
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = { class: "col-12" }
const _hoisted_18 = { class: "col-6" }
const _hoisted_19 = { class: "col-6" }
const _hoisted_20 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_button = _resolveComponent("v-button")!
  const _component_v_form_group_read_only_text = _resolveComponent("v-form-group-read-only-text")!
  const _component_v_form_group_textarea = _resolveComponent("v-form-group-textarea")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_form_group_select = _resolveComponent("v-form-group-select")!
  const _component_the_admin_video_update = _resolveComponent("the-admin-video-update")!
  const _component_the_admin_video_destroy = _resolveComponent("the-admin-video-destroy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_router_link, {
                "aria-label": _ctx.$t('Volver'),
                to: {name: 'admin.video.index'},
                class: "btn btn-link-primary btn-sm ps-0"
              }, {
                default: _withCtx(() => [
                  _hoisted_4,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('Volver')), 1)
                ]),
                _: 1
              }, 8, ["aria-label", "to"])
            ])
          ]),
          _createElementVNode("h2", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.$t('Ver')) + " ", 1),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('vídeo')), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("iframe", {
                src: _ctx.createUrl(),
                allow: "autoplay; fullscreen; picture-in-picture",
                allowfullscreen: "",
                frameborder: "0"
              }, null, 8, _hoisted_9)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("fieldset", null, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('Información')), 1),
                (_ctx.can('admin.video.update'))
                  ? (_openBlock(), _createBlock(_component_v_button, {
                      key: 0,
                      "aria-label": _ctx.$t('Editar vídeo'),
                      class: "btn-icon",
                      size: "sm",
                      variant: "secondary",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modalToShow = 'the-admin-video-update'))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_13,
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('Editar')), 1)
                      ]),
                      _: 1
                    }, 8, ["aria-label"]))
                  : _createCommentVNode("", true),
                (_ctx.can('admin.video.destroy'))
                  ? (_openBlock(), _createBlock(_component_v_button, {
                      key: 1,
                      "aria-label": _ctx.$t('Eliminar vídeo'),
                      class: "btn-icon",
                      size: "sm",
                      variant: "secondary",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modalToShow = 'the-admin-video-destroy'))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_14,
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('Eliminar')), 1)
                      ]),
                      _: 1
                    }, 8, ["aria-label"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_v_form_group_read_only_text, {
                    label: _ctx.$t('Nombre'),
                    text: _ctx.videoLoaded.name,
                    class: "mb-24"
                  }, null, 8, ["label", "text"])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_v_form_group_textarea, {
                    label: _ctx.$t('Descripción'),
                    value: _ctx.videoLoaded.description,
                    class: "mb-24",
                    "id-key": "description",
                    readonly: ""
                  }, null, 8, ["label", "value"])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_v_form_group_select, {
                    label: _ctx.$t('Categorías'),
                    class: "mb-24"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.videoLoaded.categories,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.videoLoaded.categories) = $event)),
                        options: _ctx.videoLoaded.categories,
                        class: "select-search",
                        disabled: "",
                        multiple: ""
                      }, {
                        "open-indicator": _withCtx(({ attributes }) => [
                          _createElementVNode("span", _normalizeProps(_guardReactiveProps(attributes)), null, 16)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "options"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_v_form_group_read_only_text, {
                    label: _ctx.$t('Visibilidad'),
                    text: _ctx.visibility,
                    class: "mb-24"
                  }, null, 8, ["label", "text"])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_v_form_group_read_only_text, {
                    label: _ctx.$t('Url'),
                    text: _ctx.videoLoaded.url,
                    class: "mb-24"
                  }, null, 8, ["label", "text"])
                ])
              ])
            ])
          ])
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.can('admin.video.update') &&
      _ctx.modalToShow === 'the-admin-video-update')
      ? (_openBlock(), _createBlock(_component_the_admin_video_update, {
          key: 1,
          video: _ctx.videoLoaded,
          onClosed: _cache[3] || (_cache[3] = ($event: any) => (_ctx.modalToShow = null)),
          onVideoUpdated: _ctx.loadVideo
        }, null, 8, ["video", "onVideoUpdated"]))
      : _createCommentVNode("", true),
    (_ctx.can('admin.video.destroy') &&
      _ctx.modalToShow === 'the-admin-video-destroy')
      ? (_openBlock(), _createBlock(_component_the_admin_video_destroy, {
          key: 2,
          video: _ctx.videoLoaded,
          onClosed: _cache[4] || (_cache[4] = ($event: any) => (_ctx.modalToShow = null)),
          onVideoDestroy: _ctx.loadVideo
        }, null, 8, ["video", "onVideoDestroy"]))
      : _createCommentVNode("", true)
  ]))
}